import * as loadQueueHelper from '../../../js/document/load-queue'
import Img from './main'

loadQueueHelper.add(function () {
  Img.createInstancesOnDocument()
})
